import { QueueModel } from '@/types';
import BaseService from '@/services/api/BaseService';

class QueueService extends BaseService<QueueModel> {}

export default new QueueService('queues');
